/**
 * Local feature flag controlling which design renders.
 *
 * The new look is the default. The legacy design is preserved and can be
 * brought back via either:
 *   - build-time env var:  VITE_LEGACY_DESIGN=true  (set in .env)
 *   - runtime localStorage: localStorage.setItem('fw_legacy_design', 'true')
 *
 * The localStorage override wins so the old design can be toggled locally in
 * the browser without a rebuild — handy for side-by-side comparison.
 */
const LEGACY_STORAGE_KEY = 'fw_legacy_design';

const isTruthy = (value: string | null | undefined): boolean => value === 'true' || value === '1';

export const isLegacyDesign = (): boolean => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const override = window.localStorage.getItem(LEGACY_STORAGE_KEY);
    if (override !== null) {
      return isTruthy(override);
    }
  }
  return isTruthy(import.meta.env.VITE_LEGACY_DESIGN);
};
